import { UntypedFormGroup } from '@angular/forms';
import { Questions } from './question/question.model';

// DEV-6874: question keys (ERP qu_id) shown before all others, in this order.
// 2 = Health Insurance — it converts far better when not shown next to Currency Exchange (1).
export const THIRD_PARTY_QUESTION_PRIORITY: number[] = [ 2 ];

/**
 * The ERP keys questions by qu_id, so Object.values() hands them over in
 * ascending id order. Move the priority questions to the front and keep the
 * rest in their incoming order. Returns a new array.
 */
export function orderThirdPartyQuestions( questions: Questions ): Questions {

	const prioritised = THIRD_PARTY_QUESTION_PRIORITY
		.map( key => questions.find( question => Number( question.key ) === key ) )
		.filter( ( question ): question is Questions[number] => question !== undefined );

	return [ ...prioritised, ...questions.filter( question => ! prioritised.includes( question ) ) ];
}

/**
 * The form controls belonging to one question: the main yes/no control plus
 * whichever of its (max 3) sub-question controls exist.
 */
export function questionControlKeys( form: UntypedFormGroup, questionKey: number ): string[] {

	const keys = [ 'question_' + questionKey ];

	for( const subQuestion of [ 1, 2, 3 ] ) {

		const subQuestionName = 'question_' + questionKey + '_' + subQuestion;

		if( form.contains( subQuestionName ) ) {
			keys.push( subQuestionName );
		}
	}

	return keys;
}

/**
 * The send-questions body for a single question, so each step's answer is
 * saved on its own (DEV-6874). Same shape as the full form, scoped to one key.
 */
export function buildQuestionPayload( form: UntypedFormGroup, questionKey: number ): string {

	const body: Record<string, unknown> = {
		_token:        form.controls['_token'].value,
		_existingKeys: JSON.stringify( [ questionKey ] ),
	};

	for( const key of questionControlKeys( form, questionKey ) ) {
		body[ key ] = form.controls[ key ].value;
	}

	return JSON.stringify( body );
}
